import { call, put, all, takeEvery } from 'redux-saga/effects';
import { gcApi, webApi } from 'config/axios';
import {
    FETCH_TRAINING_PLAN_BY_ID,
    FETCHING_TRAINING_PLAN,
    FETCHING_TRAINING_PLAN_SUCCESS,
    FETCHING_TRAINING_PLAN_ERROR,
    FETCH_TRAINING_PLAN_FOR_SETUP,
    FETCHING_TRAINING_PLAN_FOR_SETUP_SUCCESS,
    FETCHING_TRAINING_PLAN_FOR_SETUP_ERROR,
    FETCHING_TRAINING_PLAN_FOR_SETUP,
    CREATE_PHASED_TRAINING_PLAN,
    CREATE_PHASED_TRAINING_PLAN_ERROR,
    CREATING_PHASED_TRAINING_PLAN,
    CREATED_PHASED_TRAINING_PLAN,
    FETCH_USER_CURRENT_TRAINING_DATA,
    FETCHING_USER_CURRENT_TRAINING_DATA,
    FETCH_USER_CURRENT_TRAINING_DATA_SUCCESS,
    FETCH_USER_CURRENT_TRAINING_DATA_ERROR,
    DELETE_TRAINING_PLAN,
    DELETING_TRAINING_PLAN,
    DELETE_TRAINING_PLAN_SUCCESS,
    DELETE_TRAINING_PLAN_FAIL,
    GET_WORKOUT_SCHEDULE_BY_PERIOD,
    FETCHING_WORKOUT_SCHEDULE_BY_PERIOD,
    FETCHING_WORKOUT_SCHEDULE_BY_PERIOD_SUCCESS,
    FETCHING_WORKOUT_SCHEDULE_BY_PERIOD_ERROR,
    DELETE_TRAINING_PLAN_BY_IDS,
    DELETING_TRAINING_PLAN_BY_IDS,
    DELETE_TRAINING_PLAN_SUCCESS_BY_IDS,
    DELETE_TRAINING_PLAN_FAIL_BY_IDS
} from '../../actions/ActionTypes';
import { toQueryString } from '../../utils/UrlUtil';
import { handlingErrorCallback, handlingSuccessCallback } from 'sagas/sagasUtils';

// worker
export function* fetchTrainingPlan(action) {
    const { locale } = action;
    try {
        yield put({
            type: FETCHING_TRAINING_PLAN_FOR_SETUP
        });

        const response = yield call(webApi.get, `/web-data/training-plans/phased-training-plans/${locale}.json`, {
            baseURL: '/'
        });

        yield put({
            type: FETCHING_TRAINING_PLAN_FOR_SETUP_SUCCESS,
            trainingPlan: response && response.data ? response.data : {}
        });
    } catch (e) {
        yield put({
            type: FETCHING_TRAINING_PLAN_FOR_SETUP_ERROR
        });
    }
}
export function* createPhasedTrainingPlan(action) {
    try {
        const { payload } = action;
        yield put({
            type: CREATING_PHASED_TRAINING_PLAN
        });

        const response = yield call(
            gcApi.post,
            '/trainingplan-service/trainingplan/phased/cycling/trainingplan',
            payload
        );

        yield put({
            type: CREATED_PHASED_TRAINING_PLAN
        });
    } catch (e) {
        yield put({
            type: CREATE_PHASED_TRAINING_PLAN_ERROR,
            error: e.response
        });
    }
}

// worker
export function* fetchTrainingPlanById(action) {
    try {
        yield put({
            type: FETCHING_TRAINING_PLAN
        });

        const response = yield call(gcApi.get, `/trainingplan-service/trainingplan/phased/${action.trainingPlanId}`);

        yield put({
            type: FETCHING_TRAINING_PLAN_SUCCESS,
            trainingPlan: response && response.data ? response.data : {}
        });
    } catch (e) {
        yield put({
            type: FETCHING_TRAINING_PLAN_ERROR
        });
    }
}

export function* deleteTrainingPlanById(action) {
    try {
        yield put({
            type: DELETING_TRAINING_PLAN
        });

        yield call(gcApi.delete, `/trainingplan-service/trainingplan/trainingplan/${action.trainingPlanId}`);

        yield put({
            type: DELETE_TRAINING_PLAN_SUCCESS
        });

        if (action.callback) {
            yield call(handlingSuccessCallback, action.callback);
        }
    } catch (e) {
        yield put({
            type: DELETE_TRAINING_PLAN_FAIL
        });

        if (action.callback) {
            yield call(handlingErrorCallback, action.callback, e);
        }
    }
}

export function* getWorkoutScheduleByPeriod(action) {
    try {
        const { startDate, endDate } = action;
        yield put({
            type: FETCHING_WORKOUT_SCHEDULE_BY_PERIOD
        });

        let response = yield call(
            gcApi.get,
            `/workout-service/schedule/workoutScheduleByPeriod?startDate=${startDate}&endDate=${endDate}`
        );

        yield put({
            type: FETCHING_WORKOUT_SCHEDULE_BY_PERIOD_SUCCESS,
            workoutScheduleByPeriod: response && response.data ? response.data : {}
        });
    } catch (e) {
        yield put({
            type: FETCHING_WORKOUT_SCHEDULE_BY_PERIOD_ERROR
        });
    }
}

// worker
export function* fetchUserCurrentTrainingData(action) {
    try {
        const { payload } = action;
        const queryString = toQueryString({ ...payload });

        yield put({
            type: FETCHING_USER_CURRENT_TRAINING_DATA
        });

        const response = yield call(gcApi.get, `/fitnessstats-service/activity${queryString}`);

        yield put({
            type: FETCH_USER_CURRENT_TRAINING_DATA_SUCCESS,
            userTrainingData: response && response.data ? response.data : {}
        });
    } catch (e) {
        yield put({
            type: FETCH_USER_CURRENT_TRAINING_DATA_ERROR
        });
    }
}

export function* deleteTrainingPlanByIds(action) {
    try {
        yield put({
            type: DELETING_TRAINING_PLAN_BY_IDS
        });

        // NOTE: Can't call yield all(...) because will get a deadlock exception from API if we call them in parallel
        let calls = action.trainingPlanIds.map((trainingPlanId) => {
            return call(gcApi.delete, `/trainingplan-service/trainingplan/trainingplan/${trainingPlanId}`);
        });
        // Execute then sequentially
        for (let c of calls) {
            yield c;
        }

        yield put({
            type: DELETE_TRAINING_PLAN_SUCCESS_BY_IDS
        });

        if (action.callback) {
            yield call(handlingSuccessCallback, action.callback, { data: action.trainingPlanIds });
        }
    } catch (e) {
        yield put({
            type: DELETE_TRAINING_PLAN_FAIL_BY_IDS
        });

        if (action.callback) {
            yield call(handlingErrorCallback, action.callback, e);
        }
    }
}

// watcher
export const phasedTrainingPlanSagas = [
    takeEvery(FETCH_TRAINING_PLAN_BY_ID, fetchTrainingPlanById),
    takeEvery(GET_WORKOUT_SCHEDULE_BY_PERIOD, getWorkoutScheduleByPeriod),
    takeEvery(DELETE_TRAINING_PLAN, deleteTrainingPlanById),
    takeEvery(FETCH_TRAINING_PLAN_FOR_SETUP, fetchTrainingPlan),
    takeEvery(FETCH_USER_CURRENT_TRAINING_DATA, fetchUserCurrentTrainingData),
    takeEvery(CREATE_PHASED_TRAINING_PLAN, createPhasedTrainingPlan),
    takeEvery(DELETE_TRAINING_PLAN_BY_IDS, deleteTrainingPlanByIds)
];
